import React from 'react';
import './Spinner.css';

const Spinner = () => {
    return (
        <div className="wz-lyriapay-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default Spinner;
